import {
	daniel,
	irewande,
	kebron,
	joel,
	stella,
	lilian,
	amesi,
	wangui,
	rukome,
	pauline,
	sharon,
	margaret,
	lester,
	nancy,
} from 'assets/images';

const Members = [
	{
		id: 1,
		image: daniel,
		name: 'Daniel Mwambonu',
		title: 'Founder BWC',
	},
	{
		id: 2,
		image: irewande,
		name: 'Irewande Kolawole',
		title: 'Senior HR Assistant',
	},
	{
		id: 3,
		image: kebron,
		name: 'Kebron Abadi',
		title: 'HR Assistant',
	},
	{
		id: 4,
		image: joel,
		name: 'Joel Emoh Eyong',
		title: 'Vice President of Engineering',
	},
	{
		id: 5,
		image: stella,
		name: 'Stella Onyinye Alamezie',
		title: 'Product Owner/Manager BWC',
	},
	{
		id: 6,
		image: lilian,
		name: 'Lilian Anigbogu',
		title: 'Scrum Master BWC',
	},
	{
		id: 7,
		image: amesi,
		name: 'Amesi Gift',
		title: 'Quality Assurance Engineer BWC',
	},
	{
		id: 8,
		image: wangui,
		name: 'Wangui Njoroge',
		title: 'Product Designer BWC',
	},
	{
		id: 9,
		image: rukome,
		name: 'Rukome Ebele Eture-Edhebe',
		title: 'UX Researcher BWC',
	},
	{
		id: 10,
		image: pauline,
		name: 'Pauline Ondiek',
		title: 'Front-End Developer BWC',
	},
	{
		id: 11,
		image: sharon,
		name: 'Sharon Obinda',
		title: 'Front-End Developer BWC',
	},
	{
		id: 12,
		image: margaret,
		name: 'Margaret Maina',
		title: 'Back-End Developer BWC',
	},
	{
		id: 13,
		image: lester,
		name: 'Lester J C Membe',
		title: 'Principal Software Engineer',
	},
	{
		id: 14,
		image: nancy,
		name: 'Nancy Eke',
		title: 'Content Creator BWC',
	},
];

export default Members;
